import React, { Component } from 'react';
import { bool, func } from 'prop-types';
import FlatTab from '../../../FlatTab/FlatTab';

import './ReportTabs.scss';

export default class ReportTabs extends Component {
  static propTypes = {
    initialReportsLoaded: bool,
    favoriteFilter: bool,
    setFavoriteFilter: func,
    popularFilter: bool,
    setPopularFilter: func
  };
  constructor(props) {
    super(props);
    this.setFavorite = this.setFavorite.bind(this);
    this.setAllReports = this.setAllReports.bind(this);
    this.setPopular = this.setPopular.bind(this);
  }

  setFavorite() {
    this.props.setFavoriteFilter(true);
    this.props.setPopularFilter(false);
  }

  setAllReports() {
    this.props.setFavoriteFilter(false);
    this.props.setPopularFilter(false);
  }

  setPopular() {
    this.props.setPopularFilter(true);
    this.props.setFavoriteFilter(false);
  }

  render() {
    const className = this.props.initialReportsLoaded ? 'report__tabs' : 'report__tabs--disabled';
    return (
      <div className={className}>
        <FlatTab
          title="Favorites"
          tabClick={!this.props.favoriteFilter ? this.setFavorite : null}
          selected={this.props.favoriteFilter && !this.props.popularFilter}
          selectedClassName="report__tab--selected"
          isDisabled={!this.props.initialReportsLoaded}
        />
        <FlatTab
          title="All Reports"
          tabClick={this.props.favoriteFilter || this.props.popularFilter ? this.setAllReports : null}
          selected={!this.props.favoriteFilter && !this.props.popularFilter}
          selectedClassName="report__tab--selected"
          isDisabled={!this.props.initialReportsLoaded}
        />

        <FlatTab
          title="Popular Reports"
          tabClick={!this.props.popularFilter ? this.setPopular : null}
          selected={this.props.popularFilter}
          selectedClassName="report__tab--selected"
          isDisabled={!this.props.initialReportsLoaded}
        />
      </div>
    );
  }
}
